export const ocppTagListFilter = (textInput, items) => {
  const shortTxt = (text) => {
    return text?.toLowerCase().replace(/\s/gi, '');
  };

  const textToLowerNoSpace = shortTxt(textInput);

  const parsedList = items?.map((ocppTag) => {
    const { idTag } = ocppTag;
    return {
      hits: {
        code: shortTxt(idTag),
        ocppTag,
      },
    };
  });

  return parsedList
    ?.map((item) => {
      return (
        new RegExp(textToLowerNoSpace, 'gi').test(item.hits.code) &&
        item.hits.ocppTag
      );
    })
    .filter((res) => res !== false);
};

export const ocppUnknownTagListFilter = (textInput, items) => {
  const shortTxt = (text) => {
    return text?.toLowerCase().replace(/\s/gi, '');
  };

  const textToLowerNoSpace = shortTxt(textInput);

  const parsedList = items?.map((ocppTag) => {
    const { key } = ocppTag;
    return {
      hits: {
        code: shortTxt(key),
        ocppTag,
      },
    };
  });

  return parsedList
    ?.map((item) => {
      return (
        new RegExp(textToLowerNoSpace, 'gi').test(item.hits.code) &&
        item.hits.ocppTag
      );
    })
    .filter((res) => res !== false);
};

export const stationsListTagFilter = (textInput, items) => {
  const shortTxt = (text) => {
    if (typeof text === 'string')
      return text?.toLowerCase()?.replace(/\s/gi, '');
  };

  const parsedList = items?.map((station) => {
    const { chargeBoxId, description, address, externalId } = station;
    return {
      hits: {
        code:
          shortTxt(description) +
          shortTxt(String(address?.city)) +
          shortTxt(String(address?.state)) +
          shortTxt(String(chargeBoxId)) +
          shortTxt(String(externalId)), // + shortText(newFieldToBeSearchedToo)
        station,
      },
    };
  });

  return parsedList?.length > 0
    ? parsedList
        ?.map((item) => {
          let hits = 0;
          textInput.map((text) => {
            if (new RegExp(shortTxt(text), 'gi').test(item.hits.code)) {
              hits += 1;
            }
          });

          if (hits === textInput.length) return item.hits.station;
          else return false;
        })
        .filter((res) => {
          return res !== false;
        })
    : [];
};

export const ocppTagFilter = (ocppTags, tenantInputValue) => {
  if (tenantInputValue !== '') {
    ocppTags = ocppTags?.filter(
      (ocppTag) => String(ocppTag?.tenantPk) === String(tenantInputValue),
    );
  }

  return ocppTags;
};
